module.exports = __webpack_public_path__ + "public/images/about-exhibition/bg-desktop-1920.ff6c83879d63fc17d9a1d0f0783de009.svg";